<template>
  <div class="varBindingDialog">
    <!--对话框-->
    <el-dialog @open="handleOpen" @close="handleClose" ref="varBindingModel" width="60%" :visible.sync="modalShow" :title="title" :show-close="true" :close-on-click-modal="false"
             :content-style="{padding: '20px'}" :title-style="{'font-weight': 'bolder'}" append-to-body>
      <!--绑定变量表单，:model绑定form数据-->
      <el-form ref="varBindingForm" :model="form" label-width="80px" :rules="rules">
        <!--选择框选择变量-->
        <el-form-item label="变量" prop="varName">
          <select class="formSelect" v-model="form.varName">
            <option v-for="item in varList" :key="item.name" :value="item.name">{{ item.name }}</option>
          </select>
        </el-form-item>
        <!--选择绑定方式,只有选择了变量才能选择-->
        <el-form-item label="绑定方式" prop="bindType" v-if="label !== '延伸值'">
          <el-radio-group :disabled="!form.varName" v-model="form.bindType" @change="handleChange">
            <el-radio label="原值" v-if="bindingFeature[0]">原值</el-radio>
            <el-radio label="分段" v-if="bindingFeature[1]">分段</el-radio>
            <el-radio label="均分" v-if="bindingFeature[2]">均分</el-radio>
            <el-radio label="映射" v-if="bindingFeature[3]">映射</el-radio>
          </el-radio-group>
        </el-form-item>

        <!--选择了分段-->
        <el-form-item v-if="form.bindType === '分段'" label="分段信息" prop="partitionInfo">
          <partition-line
            :maxValue="form.valueMx"
            :minValue="form.valueMi"
            :component="component"
            v-model="form.partitionInfo"
            :selectList="selectList"
            :radioList="radioList"
            :label="label"
          ></partition-line>
        </el-form-item>
        <!--选择了均分-->
        <el-form-item v-if="form.bindType === '均分'" label="均分信息" prop="partitionInfo">
          <el-input v-model="form.equipartitionNum" label="均分段数 : " placeholder="请输入段数" class="equipartitionNum"></el-input>
          <partition-line
            :maxValue="form.valueMx"
            :minValue="form.valueMi"
            :component="component"
            v-model="form.partitionInfo"
            :selectList="selectList"
            :radioList="radioList"
            :equipartitionNum="form.equipartitionNum"
            :label="label"
          ></partition-line>
        </el-form-item>
        <!--选择了映射-->
        <template v-if="form.bindType === '映射'">
          <el-form-item  label="原值范围">
            <!--展示原值范围和映射范围-->
            <el-col :span="3">
              <el-input v-model.number="form.valueMi"></el-input>
            </el-col>
            <el-col class="line" :span="1" align="middle">-</el-col>
            <el-col :span="3">
              <el-input v-model.number="form.valueMx"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item  label="映射范围" v-if="label !== '延伸值'">
            <el-col :span="3">
              <el-input v-model.number="form.mappingMi"></el-input>
            </el-col>
            <el-col class="line" :span="1" align="middle">-</el-col>
            <el-col :span="3">
              <el-input v-model.number="form.mappingMx"></el-input>
            </el-col>
          </el-form-item>
        </template>
      </el-form>
      <el-button @click="modalShow = false">取 消</el-button>
      <el-button type="primary" @click=handleConfirm>确 定</el-button>
    </el-dialog>

    <el-dialog
        title="请设置变量的极值"
        :visible.sync="setMxVisible"
        width="30%"
        append-to-body
        :show-close="false"
        :close-on-click-modal="false"
    >
      <el-form :model="setForm">
        <el-form-item label="最小值：" label-width="80px">
          <el-input v-model.number="setForm.valueMi"></el-input>
        </el-form-item>
        <el-form-item label="最大值：" label-width="80px">
          <el-input v-model.number="setForm.valueMx"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="setMxVisible = false;form.bindType = ''">取 消</el-button>
        <el-button type="primary" @click=handleSetMxConfirm>确 定</el-button>
      </span>
    </el-dialog>
  </div>

</template>

<script>
import PartitionLine from "./PartitionLine";
import deepClone from "../../../../config/deepCopy.js";
export default {
  name: "VarBindingDialog",        // 变量绑定框
  components: {PartitionLine},
  props: {
    value: {},
    varList: Array,
    show: Boolean,
    component: String,     // 接收一下,往分段的传
    selectList: Array,
    radioList: Array,
    label: String,
  },
  data() {
    return {
      form: {                 // 变量绑定的表单数据
        varName: undefined,   // 绑定的变量名
        bindType: undefined,  // 绑定方式,原值、分段等
        partitionInfo: [],    // 分段信息
        equipartitionNum: undefined,  // 均分段数
        valueMx:100,
        valueMi:0,
        mappingMx:100,
        mappingMi:0,
      },
      setForm: {     // 用来设置最大值和最小值的表单
        valueMx:100,
        valueMi:0,
      },
      rules: {    // 表单的规则
        varName: [
          {required: true, message: '变量不能为空'}
        ],
        bindType: [
          {required: true, message: '绑定方式不能为空'}
        ],
        equipartitionNum: [
          {type: 'number', message: '均分段数需为数字'}
        ],
      },
      title: '变量绑定',
      setMxVisible: false,     // 变量绑定的极值设置是否可见
      bindingFeature: [true,true,true,true]    // 设置绑定方式是否可见
    }
  },
  methods: {
    // 初始化变量绑定
    init() {
      //console.log("当前绑定变量最后的值是",this.component)
      if (this.component === 'color-picker-component'){      // 颜色没有原值和映射
        this.bindingFeature[0] = false
        this.bindingFeature[3] = false
      }else if (this.component === 'el-switch') {      // 布尔值没有映射
        this.bindingFeature[3] = false
      }else if (this.component === 'radio-component') {  // 单选框没有原值和映射
        this.bindingFeature[0] = false;
        this.bindingFeature[3] = false;
      }
      // 当已经有变量存在时,直接复制一份给form,记录之前的操作
      if(typeof this.value == 'object') {
        this.form = deepClone(this.value)
      } else {   // 否则置为空
        this.form = {
          varName: undefined,
          bindType: undefined,
          partitionInfo: [],
          equipartitionNum: undefined,
          valueMx:100,
          valueMi:0,
          mappingMx:100,
          mappingMi:0,
        }
      }
      if (this.label === '延伸值') {    // 延伸值默认就是映射
        this.form.bindType = "映射"
      }
    },
    // 点击确定调用的函数
    handleConfirm() {
      this.$refs.varBindingForm.validate(valid => {
        if(valid) {
          if(this.form.partitionInfo !== undefined){
            // 对partitionInfo中的分段/均分 根据该区间最小值进行从小到大排序
            this.form.partitionInfo.sort(function(partition1, partition2) {
              return partition1.value - partition2.value
            })
            //let item = document.getElementsByTagName('partition-line')
            console.log("分段/均分 根据该区间最小值进行从小到大排序 ", this.form.partitionInfo)
          }
          this.$emit('input', this.form)   // 触发编辑框的input方法,用表单数据更新值
          this.modalShow = false     // 绑定框消失
        }
      })
    },
    // 修改了绑定方式调用的函数
    handleChange(val) {
      console.log("修改了绑定方式为",val)
      // 删去绑定方式特有的属性
      this.$delete(this.form, "partitionInfo")
      this.$delete(this.form, "equipartitionNum")
      this.$delete(this.form, "mappingMi")
      this.$delete(this.form, "mappingMx")
      if(val === '分段') {  // 是分段,分段信息置空
        this.$set(this.form, "partitionInfo", [])
        this.setMxVisible = true
      } else if(val === '均分') {  // 是均分,分段信息置空,默认均分一段
        this.$set(this.form, "partitionInfo", [])
        this.$set(this.form, "equipartitionNum", "1")
        this.setMxVisible = true
      } else if(val === '映射') {   // 是映射,设置映射的极值
        this.$set(this.form, "mappingMi",0)
        this.$set(this.form, "mappingMx",100)
      }
    },
    handleSetMxConfirm() {     // 设置极值的表单点击确认
      if (this.setForm.valueMx < this.setForm.valueMi) {
        this.$message({
          type: "error",
          message: "最大值不能小于最小值"
        })
        return
      }
      this.form.valueMi = this.setForm.valueMi
      this.form.valueMx = this.setForm.valueMx
      this.setMxVisible = false
    },
    handleOpen(){
      this.$bus.$emit("handle-stop-wrapper-click-listening");
    },
    handleClose(){
      this.$bus.$emit("handle-continue-wrapper-click-listening");
    }
  },
  computed: {
    modalShow: {      // 对话框是否展示,修改这个值时把父组件的show值也修改了
      get() {
        return this.show
      },
      set(val) {
        this.$emit("update:show", val)   // 调用了update:show修改了值
      }
    }
  },
  watch: {
    show: {    // 监视show的改变,当它从false改为true,需要重新初始化一下
      handler(val) {
        if(val === true)
          this.init()
      }
    }
  }
}
</script>

<style scoped>
	.equipartitionNum {
		width: 20%
	}
</style>